export const DEFAULT_LANGUAGE = 'it';
export const SUPPORTED_LANGUAGES = ['it', 'en'];

export const MESSAGES = {
  it: {
    never: 'mai',
    notAvailable: 'n/d',
    unavailableDistance: 'distanza n/d',
    onTime: 'in orario',
    lateMinutes: '{minutes} min di ritardo',
    earlyMinutes: '{minutes} min di anticipo',
    aboutOneMinute: 'circa 1 min',
    aboutMinutes: 'circa {minutes} min',
    arrivalUnavailable: 'arrivo non disponibile',
    arrivingNow: 'in arrivo ora',
    arrivingInOneMinute: 'in arrivo tra 1 minuto',
    arrivingInMinutes: 'in arrivo tra {minutes} minuti',
    nextStopDistance: '{distance} alla prossima fermata',
    nightRoute: '{route} Notturna',
    fullCoverage: 'Copertura completa',
    fullNetwork: 'Tutta la rete',
    routeA: 'Direzione A',
    routeB: 'Direzione B',
    routeUnavailable: 'Direzione n/d',
    busMarkerLabel: 'Bus {label}, {route}',
    stopMarkerLabel: 'Fermata {name}',
    addressResult: 'Risultato indirizzo',
    backToMap: 'Torna alla mappa',
    stopLineSummary: 'Fermata {stopId}{routes}',
    stopLineRoutesSuffix: ' · linee {routes}',
    stopScheduleSummaryLabel: 'Riepilogo orari fermata',
    passagesToday: '{count} passaggi nel giorno',
    realtime: 'realtime',
    scheduledPlural: 'programmati',
    stopScheduleAria: 'Orari fermata {stopId}',
    dailySchedule: 'Orari della giornata',
    today: 'Oggi',
    date: 'Data',
    stopDateSelector: 'Scegli giorno orari fermata',
    refresh: 'Aggiorna',
    refreshing: 'Aggiorno...',
    loadingStopSchedule: 'Carico gli orari della fermata...',
    noPassagesToday: 'Nessun passaggio disponibile per oggi.',
    activeTrip: 'Corsa attiva',
    realtimeRouteFallback: 'Linea {route} realtime',
    scheduledTrip: 'Corsa programmata',
    scheduledTime: 'Orario programmato',
    realtimeBus: 'bus realtime',
    scheduled: 'programmato',
    nextStop: 'Prossima',
    locationPermissionSafari: 'Accesso negato. In Safari: aA > Impostazioni sito web > Posizione > Consenti',
    locationPermissionDenied: 'Accesso alla posizione negato. Controlla i permessi del sito nel browser',
    locationGrantedNoPositionApple:
      'Safari non ha restituito la posizione. Controlla Servizi di localizzazione su iPhone e ricarica la pagina',
    locationGrantedNoPosition:
      'Il browser non ha restituito la posizione anche se il permesso risulta attivo. Ricarica la pagina e riprova',
    locationUnavailable: 'Posizione non disponibile',
    locationTimeout: 'Timeout nel rilevare la posizione',
    locationFailed: 'Impossibile rilevare la posizione',
    geolocationUnsupported: 'Geolocalizzazione non supportata da questo browser',
    locationFound: 'Posizione rilevata sulla mappa',
    enableLocationForJourney: 'Attiva la tua posizione per tracciare un percorso verso la fermata',
    journeyUnavailable: 'Percorso GTFS non disponibile',
    journeyDrawFailed: 'Impossibile disegnare il percorso verso la fermata',
    journeyChooseBothPlaces: 'Inserisci partenza e destinazione',
    journeySelectSuggestion: 'Seleziona un indirizzo dai risultati suggeriti',
    journeyPlanner: 'Calcola percorso',
    journeyFrom: 'Da',
    journeyTo: 'A',
    journeyUseLocation: 'Usa la mia posizione',
    journeySearch: 'Cerca percorso',
    journeySearching: 'Cerco...',
    journeyLoadingTitle: 'Calcolo il percorso',
    journeyLoadingDetail: 'Sto cercando le corse migliori e gli orari disponibili.',
    journeyTimeMode: 'Quando',
    journeyDepartNow: 'Partenza adesso',
    journeyDepartAtOption: 'Partenza',
    journeyArriveByOption: 'Arrivo entro le ore',
    journeyLastAvailable: 'Ultimo disponibile',
    journeyDay: 'Giorno',
    journeyDayTime: 'Giorno e ora',
    journeyInvalidTime: 'Seleziona giorno e ora validi',
    journeyPlannedFor: 'Percorso pianificato per {time}',
    journeySwap: 'Inverti partenza e destinazione',
    journeyAlternatives: 'Alternative',
    journeyArriveAt: 'Arrivo {time}',
    journeyDepartAt: 'Partenza {time}',
    journeyDepartsNow: 'Parte ora',
    journeyDepartsIn: 'Parte tra {minutes} min',
    journeyWalk: 'A piedi',
    journeyScheduled: 'Orario programmato',
    journeyLiveBus: 'Bus live {label}',
    journeyNoLiveBus: 'Corsa programmata',
    journeyOrigin: 'Partenza',
    journeyDestination: 'Destinazione',
    journeyBoardHere: 'Sali qui',
    journeyLeaveHere: 'Scendi qui',
    journeyTransferHere: 'Scendi qui',
    journeyTakeLine: 'Poi linea {line}',
    journeyBoardingStop: 'Fermata di salita',
    journeyArrivalStop: 'Fermata di discesa',
    journeyWalkToStop: 'Cammina fino a {stop}',
    journeyWalkToDestination: 'Cammina fino alla destinazione',
    journeyLineTowards: 'Linea {line} verso {destination}',
    journeyCenterBus: 'Centra sulla mappa',
    journeyGetOffAfter: 'Scendi tra {count} fermate',
    journeyGetOffAfterOneStop: 'Scendi alla prossima fermata',
    journeyBoard: 'Sali',
    journeyExit: 'Scendi',
    journeyRefreshing: 'Aggiorno percorso e orari…',
    journeyAutoRefresh: 'Aggiornamento automatico ogni minuto · ultimo {time}',
    journeyPlannerHint: 'Calcola un percorso da un luogo a un altro con le linee disponibili.',
    mapTools: 'Strumenti mappa',
    mapToolsHint: 'Aggiorna i bus live dalla mappa.',
    moreMapActions: 'Altre azioni mappa',
    lines: 'Linee',
    searchRoute: 'Cerca linea',
    liveBuses: 'Bus live',
    stops: 'Fermate',
    routePaths: 'Tracciati',
    mapUnsupported: 'Mappa non disponibile: il browser non supporta WebGL.',
    mapStartupFailed: 'Mappa non disponibile: WebGL non si e avviato su questo dispositivo.',
    routePathUnavailable: 'Tracciato linea non disponibile per questa corsa',
    routeContextFailed: 'Impossibile caricare percorso e fermate della linea',
    stopPageLoadFailed: 'Non riesco a caricare gli orari di questa fermata.',
    stopRealtimeUnavailable: 'Realtime momentaneamente non disponibile, mostro gli orari programmati.',
    addressFound: 'Indirizzo trovato sulla mappa',
    addressMinChars: 'Scrivi almeno 3 caratteri',
    addressUnavailable: 'Ricerca indirizzo non disponibile su questo browser',
    noAddressFound: 'Nessun indirizzo trovato{area}',
    chooseAddress: 'Scegli un indirizzo',
    addressSearchFailed: 'Ricerca indirizzo non riuscita',
    inArea: ' in {area}',
    mapTitleDefault: 'Rete TPL e bus live {operator}',
    refreshNow: 'Aggiorna ora',
    refreshInProgress: 'Aggiornamento in corso...',
    myLocation: 'La mia posizione',
    locating: 'Localizzo...',
    closeMap: 'Chiudi mappa',
    openFullscreen: 'Apri full screen',
    closeFullscreen: 'Chiudi mappa a schermo intero',
    openFullscreenMap: 'Apri mappa a schermo intero',
    syncInProgress: 'refresh in corso',
    syncAt: 'sync {time}',
    loadingNetwork: 'carico rete TPL',
    stopsCount: '{count} fermate',
    updatingRoutePath: 'aggiorno percorso linea',
    routeStopsCount: '{count} fermate linea',
    journeyFromYou: 'percorso da te: {duration} · {transfers} cambi',
    journeyOnMap: 'percorso: {duration} · {transfers} cambi',
    searchAddressOnMap: 'Cerca luogo, attività o indirizzo sulla mappa',
    searchAddress: 'Cerca luogo, negozio o indirizzo',
    clearAddressSearch: 'Cancella ricerca indirizzo',
    closeAddressSearch: 'Chiudi ricerca indirizzo',
    go: 'Vai',
    openAddressSearch: 'Apri ricerca indirizzo',
    addressHint: 'Cerca un indirizzo.',
    chooseMapArea: 'Scegli zona mappa: {area}',
    selectedArea: 'Zona selezionata: {area}',
    area: 'Zona',
    mapAreas: 'Zone mappa',
    closeMapAreas: 'Chiudi zone mappa',
    allArea: "Tutta l'area",
    mapStyle: 'Stile mappa',
    refreshRealtimeBus: 'Aggiorna bus realtime',
    locationHint: 'Tocca qui per geolocalizzarti.',
    backToTplNetwork: 'Torna alla rete TPL',
    mapLayers: 'Layer mappa',
    loadingRoutes: 'Carico tratte...',
    showRoutes: 'Mostra le tratte',
    routesOnMap: 'Tratte in mappa',
    close: 'Chiudi',
    quickSelection: 'Selezione rapida',
    urbanRoutes: 'Urbane',
    nightRoutes: 'Notturne',
    interurbanRoutes: 'Extraurbane',
    allRoutes: 'Tutte',
    mapView: 'Vista mappa',
    hideRoutes: 'Nascondi tratte',
    hideStops: 'Nascondi fermate',
    showStops: 'Mostra fermate',
    hideLiveBuses: 'Nascondi bus live',
    showLiveBuses: 'Mostra bus live',
    routePathMeta:
      '{count} linee selezionate · fermate {stopsVisibility} · bus live {busesVisibility}',
    visiblePlural: 'visibili',
    hiddenPlural: 'nascoste',
    hiddenMasculinePlural: 'nascosti',
    mapViewControls: 'Controlli vista mappa',
    allLines: 'Tutte le linee',
    lineOnly: 'Solo linea',
    closeStop: 'Chiudi fermata',
    loadingMapFleet: 'Caricamento mappa e flotta...',
    showAllLines: 'Mostra tutte le linee',
    lastSyncBanner: 'Ultimo sync alle {time} · refresh automatico ogni {seconds} secondi',
    visibleVehicles: 'Mezzi visibili',
    activeInFeed: '{count} attivi nel feed',
    routesOnMapStat: 'Linee in mappa',
    routeFilter: 'Filtro linea {route}',
    averageSpeed: 'Velocita media',
    averageSpeedDetail: 'Calcolata sui bus attualmente visibili',
    gtfsStops: 'Fermate GTFS',
    staticCatalogAgency: "Catalogo statico dell'agenzia",
    dataSource:
      'Origine dati: linee, fermate, orari e realtime forniti da {source}.',
    privacyNotice:
      'Non raccogliamo né salviamo dati personali: la posizione resta usata solo per le funzioni richieste.',
    developedBy: 'Sviluppato da {name}.',
    nextStopPopup: 'Prossima fermata',
    speed: 'Velocita {speed} km/h',
    detectedAt: 'Rilevato alle {time}',
    openRealtimeBus: 'Apri bus realtime linea {route} verso {destination}',
    openRoute: 'Apri linea {route} verso {destination}',
    destination: 'destinazione',
    followBus: 'Segui bus',
    openLine: 'Apri linea',
    scheduleTimeShort: 'orario',
    noUpcomingPassages: 'Nessun passaggio disponibile nelle prossime corse',
    allTimes: 'Tutti gli orari',
    tracingJourney: 'Traccio percorso...',
    routeFromHere: 'Percorso da qui',
    journeySummary: 'Percorso da te: {duration} · {transfers} cambi',
    unableLoadFleet: 'Impossibile aggiornare i mezzi. Verifica che il proxy realtime {operator} sia attivo.',
    unableLoadStatic: 'Impossibile caricare linee, fermate e orari statici {operator}.',
    unableLoadAllRoutes: 'Impossibile caricare tutti i tracciati {operator}',
    languageToggleLabel: 'Lingua interfaccia',
    languageItalian: 'Italiano',
    languageEnglish: 'Inglese',
  },
  en: {
    never: 'never',
    notAvailable: 'n/a',
    unavailableDistance: 'distance n/a',
    onTime: 'on time',
    lateMinutes: '{minutes} min late',
    earlyMinutes: '{minutes} min early',
    aboutOneMinute: 'about 1 min',
    aboutMinutes: 'about {minutes} min',
    arrivalUnavailable: 'arrival unavailable',
    arrivingNow: 'arriving now',
    arrivingInOneMinute: 'arriving in 1 minute',
    arrivingInMinutes: 'arriving in {minutes} minutes',
    nextStopDistance: '{distance} to next stop',
    nightRoute: '{route} Night',
    fullCoverage: 'Full coverage',
    fullNetwork: 'Whole network',
    routeA: 'Direction A',
    routeB: 'Direction B',
    routeUnavailable: 'Direction n/a',
    busMarkerLabel: 'Bus {label}, {route}',
    stopMarkerLabel: 'Stop {name}',
    addressResult: 'Address result',
    backToMap: 'Back to map',
    stopLineSummary: 'Stop {stopId}{routes}',
    stopLineRoutesSuffix: ' · routes {routes}',
    stopScheduleSummaryLabel: 'Stop timetable summary',
    passagesToday: '{count} trips for this day',
    realtime: 'realtime',
    scheduledPlural: 'scheduled',
    stopScheduleAria: 'Stop {stopId} timetable',
    dailySchedule: "Day timetable",
    today: 'Today',
    date: 'Date',
    stopDateSelector: 'Choose stop timetable day',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    loadingStopSchedule: 'Loading stop timetable...',
    noPassagesToday: 'No trips available for today.',
    activeTrip: 'Active trip',
    realtimeRouteFallback: 'Realtime route {route}',
    scheduledTrip: 'Scheduled trip',
    scheduledTime: 'Scheduled time',
    realtimeBus: 'realtime bus',
    scheduled: 'scheduled',
    nextStop: 'Next',
    locationPermissionSafari: 'Access denied. In Safari: aA > Website Settings > Location > Allow',
    locationPermissionDenied: 'Location access denied. Check this site permission in your browser',
    locationGrantedNoPositionApple:
      'Safari did not return your location. Check Location Services on iPhone and reload the page',
    locationGrantedNoPosition:
      'The browser did not return your location even though permission is enabled. Reload the page and try again',
    locationUnavailable: 'Location unavailable',
    locationTimeout: 'Location detection timed out',
    locationFailed: 'Unable to detect location',
    geolocationUnsupported: 'Geolocation is not supported by this browser',
    locationFound: 'Location shown on the map',
    enableLocationForJourney: 'Enable your location to draw a route to the stop',
    journeyUnavailable: 'GTFS route unavailable',
    journeyDrawFailed: 'Unable to draw the route to the stop',
    journeyChooseBothPlaces: 'Enter both origin and destination',
    journeySelectSuggestion: 'Select an address from the suggested results',
    journeyPlanner: 'Plan journey',
    journeyFrom: 'From',
    journeyTo: 'To',
    journeyUseLocation: 'Use my location',
    journeySearch: 'Find journey',
    journeySearching: 'Searching...',
    journeyLoadingTitle: 'Calculating route',
    journeyLoadingDetail: 'Looking for the best available routes and departure times.',
    journeyTimeMode: 'When',
    journeyDepartNow: 'Depart now',
    journeyDepartAtOption: 'Depart at',
    journeyArriveByOption: 'Arrive by',
    journeyLastAvailable: 'Last available',
    journeyDay: 'Day',
    journeyDayTime: 'Day and time',
    journeyInvalidTime: 'Choose a valid day and time',
    journeyPlannedFor: 'Journey planned for {time}',
    journeySwap: 'Swap origin and destination',
    journeyAlternatives: 'Alternatives',
    journeyArriveAt: 'Arrive {time}',
    journeyDepartAt: 'Depart {time}',
    journeyDepartsNow: 'Departs now',
    journeyDepartsIn: 'Departs in {minutes} min',
    journeyWalk: 'Walk',
    journeyScheduled: 'Scheduled time',
    journeyLiveBus: 'Live bus {label}',
    journeyNoLiveBus: 'Scheduled trip',
    journeyOrigin: 'Origin',
    journeyDestination: 'Destination',
    journeyBoardHere: 'Board here',
    journeyLeaveHere: 'Leave here',
    journeyTransferHere: 'Get off here',
    journeyTakeLine: 'Then route {line}',
    journeyBoardingStop: 'Boarding stop',
    journeyArrivalStop: 'Exit stop',
    journeyWalkToStop: 'Walk to {stop}',
    journeyWalkToDestination: 'Walk to your destination',
    journeyLineTowards: 'Route {line} towards {destination}',
    journeyCenterBus: 'Center on map',
    journeyGetOffAfter: 'Get off in {count} stops',
    journeyGetOffAfterOneStop: 'Get off at the next stop',
    journeyBoard: 'Board',
    journeyExit: 'Exit',
    journeyRefreshing: 'Updating route and times…',
    journeyAutoRefresh: 'Updates automatically every minute · last {time}',
    journeyPlannerHint: 'Plan a trip from one place to another with available routes.',
    mapTools: 'Map tools',
    mapToolsHint: 'Refresh live buses from the map.',
    moreMapActions: 'More map actions',
    lines: 'Routes',
    searchRoute: 'Search route',
    liveBuses: 'Live buses',
    stops: 'Stops',
    routePaths: 'Route paths',
    mapUnsupported: 'Map unavailable: this browser does not support WebGL.',
    mapStartupFailed: 'Map unavailable: WebGL did not start on this device.',
    routePathUnavailable: 'Route path unavailable for this trip',
    routeContextFailed: 'Unable to load route path and stops',
    stopPageLoadFailed: 'Unable to load this stop timetable.',
    stopRealtimeUnavailable: 'Realtime is temporarily unavailable, showing scheduled times.',
    addressFound: 'Address found on the map',
    addressMinChars: 'Type at least 3 characters',
    addressUnavailable: 'Address search is not available in this browser',
    noAddressFound: 'No address found{area}',
    chooseAddress: 'Choose an address',
    addressSearchFailed: 'Address search failed',
    inArea: ' in {area}',
    mapTitleDefault: '{operator} transit network and live buses',
    refreshNow: 'Refresh now',
    refreshInProgress: 'Refreshing...',
    myLocation: 'My location',
    locating: 'Locating...',
    closeMap: 'Close map',
    openFullscreen: 'Open full screen',
    closeFullscreen: 'Close fullscreen map',
    openFullscreenMap: 'Open fullscreen map',
    syncInProgress: 'refreshing',
    syncAt: 'sync {time}',
    loadingNetwork: 'loading transit network',
    stopsCount: '{count} stops',
    updatingRoutePath: 'updating route path',
    routeStopsCount: '{count} route stops',
    journeyFromYou: 'route from you: {duration} · {transfers} transfers',
    journeyOnMap: 'journey: {duration} · {transfers} transfers',
    searchAddressOnMap: 'Search for a place, business or address on the map',
    searchAddress: 'Search place, business or address',
    clearAddressSearch: 'Clear address search',
    closeAddressSearch: 'Close address search',
    go: 'Go',
    openAddressSearch: 'Open address search',
    addressHint: 'Search for an address.',
    chooseMapArea: 'Choose map area: {area}',
    selectedArea: 'Selected area: {area}',
    area: 'Area',
    mapAreas: 'Map areas',
    closeMapAreas: 'Close map areas',
    allArea: 'Whole area',
    mapStyle: 'Map style',
    refreshRealtimeBus: 'Refresh realtime buses',
    locationHint: 'Tap here to locate yourself.',
    backToTplNetwork: 'Back to transit network',
    mapLayers: 'Map layers',
    loadingRoutes: 'Loading routes...',
    showRoutes: 'Show routes',
    routesOnMap: 'Routes on map',
    close: 'Close',
    quickSelection: 'Quick selection',
    urbanRoutes: 'Urban',
    nightRoutes: 'Night',
    interurbanRoutes: 'Interurban',
    allRoutes: 'All',
    mapView: 'Map view',
    hideRoutes: 'Hide routes',
    hideStops: 'Hide stops',
    showStops: 'Show stops',
    hideLiveBuses: 'Hide live buses',
    showLiveBuses: 'Show live buses',
    routePathMeta:
      '{count} selected routes · stops {stopsVisibility} · live buses {busesVisibility}',
    visiblePlural: 'visible',
    hiddenPlural: 'hidden',
    hiddenMasculinePlural: 'hidden',
    mapViewControls: 'Map view controls',
    allLines: 'All lines',
    lineOnly: 'Line only',
    closeStop: 'Close stop',
    loadingMapFleet: 'Loading map and fleet...',
    showAllLines: 'Show all lines',
    lastSyncBanner: 'Last sync at {time} · automatic refresh every {seconds} seconds',
    visibleVehicles: 'Visible vehicles',
    activeInFeed: '{count} active in feed',
    routesOnMapStat: 'Routes on map',
    routeFilter: 'Route filter {route}',
    averageSpeed: 'Average speed',
    averageSpeedDetail: 'Calculated on currently visible buses',
    gtfsStops: 'GTFS stops',
    staticCatalogAgency: 'Agency static catalog',
    dataSource:
      'Data source: routes, stops, schedules and realtime data provided by {source}.',
    privacyNotice:
      'We do not collect or store personal data: your location is used only for requested features.',
    developedBy: 'Developed by {name}.',
    nextStopPopup: 'Next stop',
    speed: 'Speed {speed} km/h',
    detectedAt: 'Detected at {time}',
    openRealtimeBus: 'Open realtime bus route {route} toward {destination}',
    openRoute: 'Open route {route} toward {destination}',
    destination: 'destination',
    followBus: 'Follow bus',
    openLine: 'Open route',
    scheduleTimeShort: 'time',
    noUpcomingPassages: 'No upcoming passages available',
    allTimes: 'All times',
    tracingJourney: 'Drawing route...',
    routeFromHere: 'Route from here',
    journeySummary: 'Route from you: {duration} · {transfers} transfers',
    unableLoadFleet: 'Unable to update vehicles. Check that the {operator} realtime proxy is running.',
    unableLoadStatic: 'Unable to load {operator} static routes, stops and schedules.',
    unableLoadAllRoutes: 'Unable to load all {operator} route paths',
    languageToggleLabel: 'Interface language',
    languageItalian: 'Italian',
    languageEnglish: 'English',
  },
};

export function normalizeLanguage(language) {
  const normalizedLanguage = String(language || '').toLowerCase();
  return SUPPORTED_LANGUAGES.find((supportedLanguage) => normalizedLanguage.startsWith(supportedLanguage)) || '';
}

export function detectBrowserLanguage() {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const browserLanguages = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language];

  return browserLanguages.map(normalizeLanguage).find(Boolean) || DEFAULT_LANGUAGE;
}

export function getLocale(language = DEFAULT_LANGUAGE) {
  return normalizeLanguage(language) === 'en' ? 'en-US' : 'it-IT';
}

export function translate(language, key, values = {}) {
  const normalizedLanguage = normalizeLanguage(language) || DEFAULT_LANGUAGE;
  const template = MESSAGES[normalizedLanguage]?.[key] ?? MESSAGES[DEFAULT_LANGUAGE]?.[key] ?? key;

  return Object.entries(values).reduce(
    (message, [name, value]) => message.replaceAll(`{${name}}`, String(value)),
    template
  );
}
